import React, {useState, useEffect, useContext, useRef} from 'react';
import {Field, FieldArray, Formik} from 'formik';
import * as Yup from 'yup';
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  MenuItem,
  TextField,
  Tooltip,
} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
// import {makeStyles} from '@material-ui/core/styles';
import {ArrowBack} from '@material-ui/icons';
import PageLoader from '../../../components/PageLoader';
import {backButtonText} from '../../../util/Content';
import {ThemeContext} from '../../../themes/ThemeProvider';
import DialogBox from '../../../components/DialogBox';
import AddBillingMapping from './AddBillingMapping';
import CompaniesTable from './CompaniesTable';
import {
  fetchAllBillingIndicatorNumbersAndNames,
  fetchBillingMapData,
  postBillingMapping,
  resetAssignCompany,
  resetData,
} from '../../../redux/reducers/BillingIndicator';
import {SuccessSnackbar} from '../../../components/CustomSnackBar';
import {resetClientInfo} from '../../../redux/reducers/clientMangement/Organizaation';
// const useStyles = makeStyles((theme) => ({
//   root: {
//     'width': '100%',
//     'margin': '10px 0 0',
//     '& .MuiAccordionDetails-root': {
//       display: 'block',
//       whiteSpace: 'nowrap',
//       padding: '10px',
//     },
//   },
//   accordionDetailsStyling: {
//     backgroundColor: '#fbfbfb',
//     padding: '8px 0px 0px 0px',
//     borderRadius: '0px 0px 8px 8px',
//   },
//   heading: {
//     fontSize: theme.typography.pxToRem(16),
//     fontWeight: 600,
//     flexBasis: '50%',
//     flexShrink: 0,
//     marginLeft: 8,
//   },
//   detailsCard: {
//     backgroundColor: '#fbfbfb',
//   },
// }));
const columns = [
  {
    title: 'Actions',
  },
  {
    title: 'Company Name',
  },
  {
    title: 'Corporate Name',
  },
  {
    title: 'Site Name',
  },
  {
    title: 'Client Name',
  },
];

const isAllcolumns = [
  {
    title: 'Company Name',
  },
  {
    title: 'Corporate Name',
  },
  {
    title: 'Site Name',
  },
  {
    title: 'Client Name',
  },
];

export const removeSpecialCharacters = (inputString) => {
  const pattern = /[!@#$%^&*()+{}\[\]:;<>,.?~\\\-/]/g;
  const resultString = inputString.replace(pattern, '');
  return resultString;
};

const AddBillingNew = ({setValue, setTabLabels}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  //   const companyData = JSON.parse(sessionStorage.getItem("companyName"));
  //   companyData.unshift("ALL");
  const formDataRef = useRef();
  const drArrayHelpers = useRef();
  const {allIndicatorNumbersAndNames, successMsg, errorMsg, rowData, isLoading, billingMapData} =
    useSelector(({billingIndicator}) => billingIndicator);
  const {roleData} = useSelector(({role}) => role);
  const roleDataAccessDc = roleData?.window?.['Billing Indicator']?.BIM;
  const initialVal = {
    billingIndicatorNumber: '',
    billingIndicatorName: '',
    fields: [],
    isAll: false,
  };
  const [codePopover, setCodePopover] = useState(false);
  const [nameCodePopover, setNameCodePopover] = useState(false);
  const [initialValues, setInitialValues] = useState(initialVal);
  const [isOpen, setIsOpen] = useState(false);
  const [numbersData, setNumbersData] = useState();
  const [namesData, setNamesData] = useState();
  const [deleteBillingIds, setDeleteBillingIds] = useState([]);
  const deleteRef = useRef([]);
  useEffect(() => {
    setInitialValues(initialVal);
  }, []);

  useEffect(() => {
    if (billingMapData?.billingIndicatorNumber) {
      setCodePopover(false);
    }
  }, []);
  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetData());
        setValue(0);
      }, 2000);
    }
  }, [successMsg, errorMsg]);

  window.onclick = function() {
    setCodePopover(false);
    setNameCodePopover(false);
  };
  const handleClose = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    dispatch(fetchAllBillingIndicatorNumbersAndNames());
  }, []);
  const handleSubmit = (values) => {
    const clId = billingMapData?.clientInformationDetails?.[0]?.clientBillingId
    const clientBillingIndicatorRequestData = values?.fields?.map((item, index) => ({
      clientBillingId: item.clientBillingId ? item.clientBillingId : (clId && index === 0) ? clId  : 0,
      companyId: item?.companyName?.companyId,
      corporateId: item?.corporateName?.corporateId,
      siteId: item?.siteName?.siteId,
      serviceClientId: item?.serviceClient?.serviceClientId,
    }));
    const payload = {
      billingIndicatorNumber: Number(values?.billingIndicatorNumber),
      billingIndicatorName: values?.billingIndicatorName,
      billingIndicatorId: values?.billingIndicatorId ? values?.billingIndicatorId : 0,
      clientBilingIndicatorRequest: values?.isAll ? [] : clientBillingIndicatorRequestData,
      deletedclientBilingIds: deleteRef.current?.length > 0 ? deleteRef?.current : [],
      allClient: values?.isAll === true ? 'Y' : 'N',
    };
    dispatch(postBillingMapping(payload));
  };

  const checkNumberExist = (value) => {
    if (allIndicatorNumbersAndNames && allIndicatorNumbersAndNames?.length > 0 && value) {
      const ar = [];
      allIndicatorNumbersAndNames.filter((i) => {
        if (i?.billingIndicatorNumber === Number(value)) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkNameExist = (value) => {
    if (allIndicatorNumbersAndNames && allIndicatorNumbersAndNames?.length > 0 && value) {
      const ar = [];
      allIndicatorNumbersAndNames.filter((i) => {
        if (i?.billingIndicatorName === value) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const getBillingData = (condition) => {
    if (allIndicatorNumbersAndNames && allIndicatorNumbersAndNames.length > 0) {
      if (condition === 'billingIndicatorNumber' && numbersData) {
        return allIndicatorNumbersAndNames.filter((i) =>
          String(i?.billingIndicatorNumber).includes(numbersData),
        );
      } else if (condition === 'billingIndicatorName' && namesData) {
        return allIndicatorNumbersAndNames.filter((i) =>
          String(i?.billingIndicatorName?.toLowerCase())?.includes(namesData?.toLowerCase()),
        );
      }
    }
    return [];
  };

  const validationSchema = Yup.object().shape({
    billingIndicatorNumber: !billingMapData?.billingIndicatorNumber ?
      Yup.string()
        .required('Billing Indicator Number is required')
        .min(4, "Billing Indicator Number cannot be less than 4 digits")
        .test(
          'billingIndicatorNumber',
          'Billing Indicator Number already exists',
          (value) => !checkNumberExist(value),
        )
        .test(
          'billingIndicatorNumber',
          'Billing Indicator Number should not contain Special Characters',
          (value) => {
            const specialCharacterRegex = /[0-9]/;
            if (specialCharacterRegex.test(value)) {
              return true;
            }
            return false;
          },
        ) :
      null,
    billingIndicatorName: !billingMapData?.billingIndicatorName ?
      Yup.string()
        .required('Billing Indicator Name is required')
        .test(
          'billingIndicatorName',
          'Billing Indicator Name already exists',
          (value) => !checkNameExist(value),
        ) :
      null,
  });
  const allOptions = [
    {
      companyName: {
        companyId: null,
        companyName: 'All',
      },
      corporateName: {
        corporateId: null,
        corporateName: 'All',
      },
      siteName: {
        siteId: null,
        siteName: 'All',
      },
      serviceClient: {
        serviceClientId: null,
        serviceClientName: 'All',
      },
    },
  ];
  useEffect(() => {
    if (rowData?.billingIndicatorId) {
      dispatch(fetchBillingMapData(rowData?.billingIndicatorId));
    }
  }, [rowData?.billingIndicatorId]);

  function convertArray(inputArray) {
    return inputArray?.map((item) => ({
      clientBillingId: item?.clientBillingId,
      siteName: {
        siteId: item?.siteId,
        siteName: item?.siteName,
      },
      corporateName: {
        corporateId: item?.corporateId,
        corporateName: item?.corporateName,
      },
      companyName: {
        companyId: item?.companyId,
        companyName: item?.companyName,
      },
      serviceClient: {
        serviceClientId: item?.serviceClientId,
        serviceClientName: item?.serviceClientName,
      },
    }));
  }

  useEffect(() => {
    setInitialValues({
      billingIndicatorId: billingMapData?.billingIndicatorId || 0,
      billingIndicatorNumber: billingMapData?.billingIndicatorNumber ?
        billingMapData?.billingIndicatorNumber :
        '',
      billingIndicatorName: billingMapData?.billingIndicatorName ?
        billingMapData?.billingIndicatorName :
        '',
      isAll: billingMapData?.allClient === 'Y',
      fields:
        billingMapData?.allClient === 'Y' ?
          allOptions :
          billingMapData?.clientInformationDetails ?
            convertArray(billingMapData?.clientInformationDetails) :
            [],
    });
  }, [billingMapData]);
  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        innerRef={formDataRef}
      >
        {(props) => {
          const {
            values,
            setFieldValue,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            resetForm,
          } = props;
          return (
            <>
              <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <div className="button-table-spacing-mb justify-content-between new-standard-textfields">
                  <Button
                    variant="outlined"
                    type="button"
                    disabled={isLoading}
                    className={`search-btn mx-1 ${classes.buttonRoot}`}
                    onClick={() => {
                      setValue(0);
                      setTabLabels([]);
                    }}
                  >
                    <ArrowBack className="mr-2" />
                    {backButtonText}
                  </Button>
                </div>
                <div className="form-row  new-standard-textfields">
                  <div className={`col-sm-6 col-md-4 col-lg-4 form-group  mr-3`}>
                    <TextField
                      placeholder="Enter Billing Indicator Number"
                      margin="dense"
                      name="billingIndicatorNumber"
                      variant="outlined"
                      type="text"
                      inputProps={{
                        min: 0,
                        maxLength: 4,
                      }}
                      onKeyPress={(e) => {
                        const inputValue = e.key;
                        if (/[^0-9]/.test(inputValue)) {
                          e.preventDefault();
                        }
                      }}
                      label="Billing Indicator Number"
                      id="billingIndicatorNumber"
                      onChange={(e) => {
                        setFieldValue('billingIndicatorNumber', e.target.value);
                        if (e.target.value) {
                          setCodePopover(true);
                          setNumbersData(e.target.value);
                        } else if (e.target.value === '') {
                          setCodePopover(false);
                        }
                      }}
                      InputProps={{
                        min: 1,
                      }}
                      disabled={billingMapData?.billingIndicatorNumber}
                      value={values.billingIndicatorNumber}
                      fullWidth
                      touched={touched.billingIndicatorNumber}
                      required
                      onBlur={handleBlur}
                      error={Boolean(
                        errors.billingIndicatorNumber && touched.billingIndicatorNumber,
                      )}
                    />
                    <FormHelperText variant="outlined" style={{position: 'relative'}}>
                      {touched.billingIndicatorNumber && errors.billingIndicatorNumber}
                    </FormHelperText>
                    <div className="windowcode-popover Add-trigger-group-popover">
                      {codePopover &&
                        getBillingData('billingIndicatorNumber')?.map((data, i) => (
                          <MenuItem key={i}>{data?.billingIndicatorNumber}</MenuItem>
                        ))}
                    </div>
                  </div>
                  <div className={`col-sm-6 col-md-4 col-lg-4 form-group`}>
                    <TextField
                      placeholder="Enter Billing Indicator Name"
                      margin="dense"
                      name="billingIndicatorName"
                      variant="outlined"
                      label="Billing Indicator Name"
                      onChange={(e) => {
                        setFieldValue('billingIndicatorName', e.target.value);
                        if (e.target.value) {
                          setNameCodePopover(true);
                          setNamesData(e.target.value);
                        } else if (e.target.value === '') {
                          setNameCodePopover(false);
                        }
                      }}
                      value={values.billingIndicatorName}
                      fullWidth
                      touched={touched.billingIndicatorName}
                      required
                      onBlur={handleBlur}
                      error={Boolean(errors.billingIndicatorName && touched.billingIndicatorName)}
                    />
                    <FormHelperText variant="outlined" style={{position: 'relative'}}>
                      {touched.billingIndicatorName && errors.billingIndicatorName}
                    </FormHelperText>
                    <div className="windowcode-popover Add-trigger-group-popover">
                      {nameCodePopover &&
                        getBillingData('billingIndicatorName')?.map((data, i) => (
                          <MenuItem key={i}>{data?.billingIndicatorName}</MenuItem>
                        ))}
                    </div>
                  </div>
                  <div className="form-group col-sm-4 col-md-4 col-lg-3  global-fields-checkbox ml-4">
                    <Tooltip title="Applied To All">
                      <FormControl component="fieldset">
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={(e, value) => {
                                handleChange(e);
                                setFieldValue('isAll', e.target.checked);
                                if (values?.isAll) {
                                  setFieldValue('fields', []);
                                } else {
                                  setFieldValue('fields', allOptions);
                                }
                              }}
                              name="isAll"
                              disabled={values?.fields?.length > 0 && values?.isAll === false}
                              checked={values?.isAll}
                            />
                          }
                          label="Is ALL"
                          labelPlacement="end"
                        />
                      </FormControl>
                    </Tooltip>
                  </div>
                </div>
                <FieldArray
                  name="fields"
                  render={(arrayHelpers) => {
                    drArrayHelpers.current = arrayHelpers;
                    return (
                      <>
                        <div
                          className={
                            'mui-custom-table-container custom-table  pt-0 global-field-table text-center-table new-standard-textfields '
                          }
                        >
                          <div
                            className={
                              'table-header justify-content-end new-standard-textfields m-2'
                            }
                          >
                            <Button
                              variant="outlined"
                              className={`search-btn mx-1 ${classes.buttonRoot}`}
                              onClick={() => {
                                setIsOpen(true);
                                // dispatch(resetClientInfoData());
                                dispatch(resetClientInfo());
                                dispatch(resetAssignCompany());
                              }}
                              disabled={values?.isAll || !roleDataAccessDc?.add}

                              startIcon={<AccountTreeIcon />}
                            >
                              Assign Company
                            </Button>
                          </div>
                          <table>
                            <thead className="recFormat-header-container">
                              <tr>
                                {!values?.isAll ?
                                  columns?.map(
                                    ({title, hidden = false}) =>
                                      !hidden && (
                                        <th key={title} className="recFormat-header">
                                          {title}
                                        </th>
                                      ),
                                  ) :
                                  isAllcolumns?.map(
                                    ({title, hidden = false}) =>
                                      !hidden && (
                                        <th key={title} className="recFormat-header">
                                          {title}
                                        </th>
                                      ),
                                  )}
                              </tr>
                            </thead>
                            {values.fields?.length > 0 ? (
                              <tbody className="recFormat-body">
                                {values.fields.map((field, index) => (
                                  <>
                                    <Field
                                      key={index}
                                      name={'fields' + '[' + index + ']'}
                                      component={CompaniesTable}
                                      index={index}
                                      columns={columns}
                                      deleteRef={deleteRef}
                                      values={values}
                                      deleteBillingIds={deleteBillingIds}
                                      setDeleteBillingIds={setDeleteBillingIds}
                                      setFieldValue={setFieldValue}
                                      drArrayHelpers={drArrayHelpers}
                                    />
                                  </>
                                ))}
                              </tbody>
                            ) : (
                              <tbody>
                                <tr>
                                  <td colSpan={columns.length}>
                                    No records to display
                                    {/* To add fields to your report click the
                                    "Add Fields" button in the top right of this section. */}
                                  </td>
                                </tr>
                              </tbody>
                            )}
                          </table>
                        </div>
                      </>
                    );
                  }}
                />
                <div
                  className={
                    'd-flex justify-content-center align-items-center mt-3 new-standard-textfields'
                  }
                >
                  <Button
                    variant="outlined"
                    type="reset"
                    className={`reset-btn mr-1 ${classes.buttonRoot}`}
                    onClick={() => {
                      resetForm(initialValues);
                    }}
                  >
                    Reset
                  </Button>
                  <Button
                    variant="outlined"
                    type="submit"
                    className={`search-btn ml-1 ${classes.buttonRoot}`}
                    onClick={() => {
                      if (values?.fields?.length === 0) {
                        setFieldValue('isAll', true);
                        setFieldValue('fields', allOptions);
                      }
                    }}
                  >
                    Save
                  </Button>
                </div>
                <DialogBox
                  open={isOpen}
                  dialogClose={handleClose}
                  title={'Assign Company'}
                  maxWidth="md"
                >
                  <AddBillingMapping
                    setFieldCompany={setFieldValue}
                    formVal={values}
                    setInitialValues={setInitialValues}
                    setIsOpen={setIsOpen}
                  />
                </DialogBox>
              </form>
            </>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default AddBillingNew;
